export type ApplicationStatus = {
	name: string;
	subStatuses?: Array<{ id: number; name: string }>;
};

export const getSubStatuses = statuses =>
	statuses?.map(({ id }) => {
		return id;
	});
